import PropTypes from 'prop-types';
import Icon from "../Icon/Icon";
import { isFunction } from 'lodash';
import cn from "../../../utils/cn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AddRemoveButtons = _ref => {
  let {
    className = "",
    iconSize = 18,
    index,
    length,
    customHideRemoveButton = undefined,
    onAddClick,
    onRemoveClick,
    color = "brand-blue"
  } = _ref;
  const hideAddButton = count => index !== count - 1;
  const hideRemoveButton = count => {
    if (isFunction(customHideRemoveButton)) {
      return customHideRemoveButton();
    }
    return index === 0 && count <= 1;
  };
  const containerClasses = cn('flex', className);
  return /*#__PURE__*/_jsxs("div", {
    className: containerClasses,
    children: [!hideRemoveButton(length) && /*#__PURE__*/_jsx("button", {
      onClick: () => onRemoveClick(index),
      type: "button",
      tabIndex: "0",
      title: "Remove",
      className: `cursor-pointer flex items-center ${!hideAddButton(length) ? "mr-1" : ""}`,
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "MinusCircle",
        size: iconSize,
        color: color
      })
    }), !hideAddButton(length) && /*#__PURE__*/_jsx("button", {
      onClick: () => onAddClick(index),
      type: "button",
      tabIndex: "0",
      title: "Add",
      className: "cursor-pointer flex items-center",
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "Add",
        size: iconSize,
        color: color
      })
    })]
  });
};
AddRemoveButtons.propTypes = {
  className: PropTypes.string,
  customHideRemoveButton: PropTypes.func,
  onAddClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  iconSize: PropTypes.number,
  index: PropTypes.number.isRequired,
  length: PropTypes.number.isRequired,
  color: PropTypes.string
};
export default AddRemoveButtons;
//# sourceMappingURL=AddRemoveButtons.js.map